import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import ons from 'onsenui'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import { init } from 'modules/root'
import { authInitialized } from 'modules/auth'
import { installConsoleTimestamps } from 'modules/root/logging'

import * as Sentry from '@sentry/browser'

let deviceReady = false

document.addEventListener(
	'deviceready', 
	function() {
		console.log('STARTUP: Early device ready')
		deviceReady = true
	},
	false)

Sentry.init({
	dsn: 'https://e6c0d91770f7410bbc111e9fbf4571ca@sentry.io/1447634',
})

/* After Sentry, so we prefix its console wrapper rather than it wrapping our prefix and doubling it */
installConsoleTimestamps()

registerServiceWorker()

// if (process.env.NODE_ENV !== 'production') {
// 	const {whyDidYouUpdate} = require('why-did-you-update')
// 	whyDidYouUpdate(React)
// }

declare global {
	interface Navigator {
		splashscreen?: {
			hide: () => void
			show: () => void
		}
	}
}

function hideLaunchScreen() {
	if (navigator.splashscreen) {
		console.log('STARTUP: hiding splash screen')
		navigator.splashscreen.hide()
	}
}

function startApp() {
	console.log('STARTUP: Starting app')
	init().then(() => {
		const root = ReactDOM.createRoot(document.getElementById('root')!)
		root.render(
			<App />,
		)
		// Wait for auth state before hiding the native splash screen,
		// so the user doesn't see the login form flash.
		authInitialized.then(hideLaunchScreen)
	})
}

ons.ready(function() {
	/* Don't wait for deviceready when debugging in the browser */
	if (!ons.platform.isWebView()) {
		console.log('STARTUP: Starting app automatically as not running in Cordova')
		startApp()
	} else if (deviceReady) {
		console.log('STARTUP: Cordova already signalled readiness…')
		startApp()
	} else {
		console.log('STARTUP: Waiting for Cordova to signal readiness…')
		document.addEventListener(
			'deviceready',
			function() {
				console.log('STARTUP: Device ready')
				startApp()
			},
			false)
	}
})
